import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';
import {Link} from 'react-router-dom';

export default class TopMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobMenuVisible: false
    };
  }

  toggleMobMenu() {
    this.setState({ mobMenuVisible: !this.state.mobMenuVisible });
  }

  gotoPage(link) {
    window.location.pathname = link;
  }

  render() {
    return (
      <div className="top-menu">
        <Row className="full-width">
          <Col md={12} sm={12} xs={12} className="org-additional-buttons">
            <div className="le-logo-container">
              <img src="/images/le.png" height="50" />
            </div>
            <div className="current_user">
              <Link to={'/settings'} className="loggedin_user">
                {(() => {
                  if(this.props.userData['profile_picture'] === '') {
                    return (
                      <img alt={this.props.userData['email']} src="/images/user.png" className="img-circle" />
                    );
                  } else {
                    return (
                      <img alt={this.props.userData['email']} src={this.props.userData} onError={(event)=>event.target.setAttribute("src","/images/user.png")} />
                    );
                  }
                })()}
                {(() => {
                  if(this.props.userData['email'] !== '') {
                    return (
                      <span>{this.props.userData['email']}</span>
                    );
                  } else {
                    return (
                      <span>{this.props.userData['email']}</span>
                    );
                  }
                })()}
              </Link>
              <div className="logout-user-button-item" onClick={this.props.logoutUser}>
                <i className="fa fa-sign-out"></i>
              </div>
              {!this.state.mobMenuVisible ? (
                <div className="mobile-menu-button" onClick={this.toggleMobMenu.bind(this)}>
                  <i className="fa fa-bars"></i>
                </div>
              ) : (
                <div className="mobile-menu-button" onClick={this.toggleMobMenu.bind(this)}>
                  <i className="fa fa-times"></i>
                </div>
              )}
            </div>
          </Col>
        </Row>
        {this.state.mobMenuVisible ? (
          <div className="mobile-menu-container">
            <ul className="mobile-menu-items">
              <li className="mobile-menu-item">
                <span onClick={this.gotoPage.bind(this, '/manage-swayam')}>Manage Swayam <i className="fa fa-chevron-down"></i></span>
                <ul className="mobile-menu-items">
                  <li className="mobile-menu-item">
                    <span onClick={this.gotoPage.bind(this, '/manage-payments')}>Manage Payments</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        ) : (null)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Headers/TopMenu.js